import { render, staticRenderFns } from "./step-abc.vue?vue&type=template&id=347acbbe&scoped=true"
import script from "./step-abc.vue?vue&type=script&setup=true&lang=ts"
export * from "./step-abc.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./step-abc.vue?vue&type=style&index=0&id=347acbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347acbbe",
  null
  
)

export default component.exports